import React from "react";
import { Avatar } from "@/components/peeps/ui";
import { colors } from "@/lib/theme";

// Stacked friend avatars + "N friends going" social proof.
// `friends` is a list of {id, display_name, profile_photo_url}.
export function FriendsGoing({ friends, size = 20, max = 4, accent = colors.success, compact = false }) {
  const list = friends || [];
  if (list.length === 0) return null;
  const shown = list.slice(0, max);
  const extra = list.length - shown.length;

  const names =
    list.length === 1
      ? list[0].display_name
      : list.length === 2
      ? `${list[0].display_name} and ${list[1].display_name}`
      : `${list[0].display_name}, ${list[1].display_name} +${list.length - 2}`;

  const label = compact
    ? `${list.length} friend${list.length === 1 ? "" : "s"} going`
    : `${names} ${list.length === 1 ? "is" : "are"} going`;

  return (
    <div data-testid="friends-going" className="flex items-center gap-2 min-w-0">
      <div className="flex items-center">
        {shown.map((f, i) => (
          <div key={f.id} style={{ marginLeft: i === 0 ? 0 : -size * 0.35, zIndex: shown.length - i }}
            className="rounded-full" >
            <div className="rounded-full" style={{ padding: 1.5, background: colors.surfaceSecondary }}>
              <Avatar name={f.display_name} uri={f.profile_photo_url} size={size} />
            </div>
          </div>
        ))}
        {extra > 0 && (
          <div style={{ marginLeft: -size * 0.35, width: size + 3, height: size + 3, background: colors.surfaceTertiary, border: `1px solid ${colors.border}` }}
            className="rounded-full flex items-center justify-center">
            <span className="font-mono2 font-bold" style={{ fontSize: size * 0.42, color: colors.onSurfaceTertiary }}>+{extra}</span>
          </div>
        )}
      </div>
      <span className="font-display font-medium text-[11.5px] truncate" style={{ color: accent }}>{label}</span>
    </div>
  );
}
